import { MapPin, Award, Clock, Users } from "lucide-react";
const SEOContent = () => {
  return <section className="py-24 bg-gradient-to-b from-background to-background-gray relative overflow-hidden">
      {/* Decorative elements */}
      <div className="absolute top-0 right-0 w-96 h-96 bg-accent/5 rounded-full blur-3xl"></div>
      
      <div className="container mx-auto px-6 relative z-10">
        {/* Hero SEO Section */}
        <div className="max-w-5xl mx-auto text-center mb-20">
          <div className="inline-block px-6 py-2 bg-primary/10 text-primary font-semibold rounded-full mb-6 text-sm uppercase tracking-wider">
            Votre Expert Local
          </div>
          <h2 className="text-4xl md:text-5xl font-extrabold mb-8 text-primary">
            Couvreur Professionnel à Treillières (44119)
          </h2>
          <p className="text-xl text-muted-foreground mb-8 leading-relaxed max-w-4xl mx-auto">
            <strong>Jacky Couverture</strong>, votre artisan couvreur-zingueur à Treillières depuis plus de 15 ans. 
            Spécialiste de la <strong>rénovation de toiture tuile, ardoise et zinc</strong>, nous intervenons rapidement dans toute la 
            Loire-Atlantique pour tous vos travaux de couverture : réfection complète, réparation d'urgence, isolation thermique, 
            traitement hydrofuge, pose de Velux et zinguerie. <strong>Devis gratuit sous 24h</strong> et <strong>intervention d'urgence sous 2h</strong>.
          </p>
        </div>

        {/* Services Grid */}
        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8 mb-20">
          <div className="text-center p-8 rounded-2xl bg-card shadow-lg hover:shadow-2xl transition-all duration-300 hover:-translate-y-3 group">
            <div className="w-16 h-16 mx-auto mb-6 rounded-2xl bg-gradient-to-br from-accent/20 to-secondary/20 flex items-center justify-center transition-transform duration-300 group-hover:scale-110 group-hover:rotate-6">
              <MapPin className="w-8 h-8 text-accent" />
            </div>
            <h3 className="text-xl font-bold mb-3 text-primary group-hover:text-accent transition-colors">Zone d'intervention</h3>
            <p className="text-muted-foreground font-medium">
              <a href="/couvreur-treillieres" className="hover:text-accent transition-colors underline">
                Treillières
              </a>
              , Nantes, Saint-Mars-du-Désert, Vigneux-de-Bretagne
            </p>
          </div>
          <div className="text-center p-8 rounded-2xl bg-card shadow-lg hover:shadow-2xl transition-all duration-300 hover:-translate-y-3 group">
            <div className="w-16 h-16 mx-auto mb-6 rounded-2xl bg-gradient-to-br from-accent/20 to-secondary/20 flex items-center justify-center transition-transform duration-300 group-hover:scale-110 group-hover:rotate-6">
              <Award className="w-8 h-8 text-accent" />
            </div>
            <h3 className="text-xl font-bold mb-3 text-primary group-hover:text-accent transition-colors">Expertise Certifiée</h3>
            <p className="text-muted-foreground font-medium">15+ ans d'expérience, garantie décennale, assurance responsabilité civile</p>
          </div>
          <div className="text-center p-8 rounded-2xl bg-card shadow-lg hover:shadow-2xl transition-all duration-300 hover:-translate-y-3 group">
            <div className="w-16 h-16 mx-auto mb-6 rounded-2xl bg-gradient-to-br from-accent/20 to-secondary/20 flex items-center justify-center transition-transform duration-300 group-hover:scale-110 group-hover:rotate-6">
              <Clock className="w-8 h-8 text-accent" />
            </div>
            <h3 className="text-xl font-bold mb-3 text-primary group-hover:text-accent transition-colors">Réactivité</h3>
            <p className="text-muted-foreground font-medium">Urgences 7j/7, intervention sous 2h, devis gratuit sous 24h avec déplacement inclus</p>
          </div>
          <div className="text-center p-8 rounded-2xl bg-card shadow-lg hover:shadow-2xl transition-all duration-300 hover:-translate-y-3 group">
            <div className="w-16 h-16 mx-auto mb-6 rounded-2xl bg-gradient-to-br from-accent/20 to-secondary/20 flex items-center justify-center transition-transform duration-300 group-hover:scale-110 group-hover:rotate-6">
              <Users className="w-8 h-8 text-accent" />
            </div>
            <h3 className="text-xl font-bold mb-3 text-primary group-hover:text-accent transition-colors">Satisfaction</h3>
            <p className="text-muted-foreground font-medium">500+ clients satisfaits, avis 5 étoiles</p>
          </div>
        </div>

        {/* SEO Content Sections */}
        <div className="grid md:grid-cols-2 gap-12 mb-20">
          <div className="bg-card p-8 rounded-2xl shadow-lg">
            <h3 className="text-3xl font-extrabold mb-8 text-primary">Couvreur à Treillières : Nos Services</h3>
            <div className="space-y-4 text-muted-foreground">
              <p>
                <strong>Rénovation de toiture à Treillières :</strong> Notre équipe de couvreurs professionnels intervient pour tous vos projets de 
                <strong> réfection complète de toiture</strong>. Spécialistes de la <strong>couverture en tuile terre cuite, tuile béton, ardoise naturelle et zinc</strong>, 
                nous garantissons un travail de qualité respectant les <strong>normes DTU (Documents Techniques Unifiés)</strong> et les règles de l'art. 
                Pose de <strong>sous-toiture HPV (Haute Perméabilité à la Vapeur)</strong>, remplacement de liteaux, traitement de charpente si nécessaire.
              </p>
              <p>
                <strong>Réparation urgente de toiture :</strong> Fuite après tempête, <strong>tuiles cassées ou envolées</strong>, gouttière bouchée ou arrachée, 
                <strong>infiltration d'eau</strong>, problème de faîtage ou de noue ? Nous intervenons en urgence 7j/7 sur Treillières et toutes les communes de 
                Loire-Atlantique pour <strong>sécuriser votre habitation sous 2h</strong>. Service de dépannage avec bâchage provisoire et réparation définitive rapide.
              </p>
              <p>
                <strong>Isolation thermique de toiture :</strong> Améliorez les <strong>performances énergétiques</strong> de votre maison avec nos solutions 
                d'isolation des combles et toiture. <strong>Isolation par l'intérieur (sous-rampants)</strong> ou <strong>isolation par l'extérieur (sarking)</strong> 
                avec isolants performants : <strong>laine de roche, laine de verre, polyuréthane</strong>. Éligible aux aides <strong>MaPrimeRénov'</strong> et 
                <strong>Prime CEE</strong>.
              </p>
              <p>
                <strong>Zinguerie et évacuation des eaux pluviales :</strong> Pose et réparation de <strong>gouttières pendantes ou rampantes</strong>, 
                <strong>chéneaux, descentes EP</strong>, noues, solins, bavettes et bandes de rive en <strong>zinc, cuivre, aluminium ou PVC</strong>. 
                Respect des pentes et sections de collecte selon les <strong>normes NF DTU 40.5</strong>.
              </p>
            </div>
          </div>
          
          <div className="bg-card p-8 rounded-2xl shadow-lg">
            <h3 className="text-3xl font-extrabold mb-8 text-primary">
              Pourquoi Choisir Jacky Couverture ?
            </h3>
            <div className="space-y-4 text-muted-foreground">
              <p>
                <strong>Artisan couvreur local à Treillières :</strong> Basés au cœur de Treillières près de la zone d'activité de la Madeleine, 
                nous connaissons parfaitement les <strong>spécificités architecturales</strong> de la région nantaise (maisons traditionnelles, 
                longères rénovées, pavillons contemporains) et les contraintes climatiques (humidité, vents d'ouest, gel hivernal). 
                Proximité avec la mairie, l'église Saint-Symphorien et tous les quartiers résidentiels.
              </p>
              <p>
                <strong>Devis transparent :</strong> Nos devis sont clairs, détaillés poste par poste 
                et sans frais cachés. Aucune surprise, nous nous engageons contractuellement sur nos délais d'intervention. 
                <strong>Devis gratuit</strong> avec déplacement inclus dans un rayon de 30 km autour de Treillières. Paiement échelonné possible.
              </p>
              <p>
                <strong>Matériaux de qualité professionnelle :</strong> Nous travaillons exclusivement avec des <strong>négoces reconnus</strong> 
                (Point P, Samse, Larivière) et sélectionnons les meilleurs matériaux adaptés au climat de Loire-Atlantique. 
                <strong>Tuiles Imerys, ardoises naturelles d'Espagne</strong>, <strong>sous-toiture Delta-Maxx ou Ampack</strong>, 
                <strong>isolants Rockwool ou Isover</strong>. Garanties fabricants de 10 à 30 ans selon les produits.
              </p>
              <p>
                <strong>Garanties et assurances :</strong> Tous nos chantiers sont couverts par notre <strong>garantie décennale</strong> souscrite 
                auprès de la MAAF, notre <strong>garantie biennale</strong> sur les équipements et notre <strong>assurance responsabilité civile 
                professionnelle</strong>. Garantie de parfait achèvement pendant 1 an après réception des travaux.
              </p>
            </div>
          </div>
        </div>

        {/* Local SEO Section */}
        <div className="p-10 bg-card rounded-2xl shadow-2xl">
          <h3 className="text-3xl md:text-4xl font-extrabold mb-10 text-center text-primary">
            Intervention dans toute la Loire-Atlantique
          </h3>
          <div className="grid md:grid-cols-3 gap-8 text-center">
            <div className="p-6 bg-gradient-to-br from-accent/5 to-transparent rounded-xl">
              <h4 className="font-bold text-xl mb-4 text-primary">Secteur Nord</h4>
              <p className="text-muted-foreground font-medium leading-relaxed">
                Treillières, Saint-Mars-du-Désert, Vigneux-de-Bretagne, Grandchamp-des-Fontaines, Sucé-sur-Erdre
              </p>
            </div>
            <div className="p-6 bg-gradient-to-br from-secondary/5 to-transparent rounded-xl">
              <h4 className="font-bold text-xl mb-4 text-primary">Nantes Métropole</h4>
              <p className="text-muted-foreground font-medium leading-relaxed">
                Nantes, Orvault, Sautron, La Chapelle-sur-Erdre, Carquefou, Thouaré-sur-Loire
              </p>
            </div>
            <div className="p-6 bg-gradient-to-br from-accent/5 to-transparent rounded-xl">
              <h4 className="font-bold text-xl mb-4 text-primary">Secteur Ouest</h4>
              <p className="text-muted-foreground font-medium leading-relaxed">
                Indre, Couëron, Saint-Herblain, Sautron, Le Pellerin, Bouguenais
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>;
};
export default SEOContent;